import React from "react";
import { motion } from "framer-motion";
import { PROCESS_STEPS } from "../content";

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative section-pad"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl"
        >
          <div className="text-[#27C6FF] uppercase tracking-[0.3em] text-xs mb-5 font-heading">
            How It Works
          </div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05]">
            A five-step path to
            <br />
            <span className="gradient-text">a different version of you.</span>
          </h2>
        </motion.div>

        <div className="mt-16 relative">
          {/* Vertical glowing line */}
          <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[#7A2BFF] to-transparent md:-translate-x-1/2" />

          <div className="space-y-12">
            {PROCESS_STEPS.map((step, i) => {
              const left = i % 2 === 0;
              return (
                <motion.div
                  key={step.n}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.6, delay: i * 0.05 }}
                  className={`relative grid md:grid-cols-2 gap-6 items-center ${
                    left ? "" : "md:[&>div:first-child]:order-2"
                  }`}
                  data-testid={`process-step-${step.n}`}
                >
                  <div className={`pl-16 md:pl-0 ${left ? "md:pr-16 md:text-right" : "md:pl-16"}`}>
                    <div className="font-display text-6xl md:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#7A2BFF] to-[#27C6FF] opacity-60">
                      {step.n}
                    </div>
                    <h3 className="font-display font-bold text-2xl md:text-3xl text-white mt-2">
                      {step.title}
                    </h3>
                    <p className="mt-3 text-[#D8CCFF] text-sm md:text-base font-body max-w-md md:ml-auto">
                      {step.desc}
                    </p>
                  </div>

                  {/* Node */}
                  <div className="absolute left-6 md:left-1/2 -translate-x-1/2 w-5 h-5 rounded-full bg-gradient-to-br from-[#7A2BFF] to-[#27C6FF] shadow-[0_0_28px_rgba(122,43,255,0.7)]">
                    <div className="absolute inset-0 rounded-full bg-white/50 animate-ping opacity-40" />
                  </div>

                  <div className="hidden md:block" />
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
